var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.99998C6.32608 9.99998 7.59785 9.47319 8.53553 8.53551C9.47322 7.59783 10 6.32606 10 4.99998C10 3.67389 9.47322 2.40213 8.53553 1.46444C7.59785 0.526761 6.32608 -2.28882e-05 5 -2.28882e-05C3.67392 -2.28882e-05 2.40215 0.526761 1.46447 1.46444C0.526784 2.40213 0 3.67389 0 4.99998C0 6.32606 0.526784 7.59783 1.46447 8.53551C2.40215 9.47319 3.67392 9.99998 5 9.99998V9.99998ZM5.625 2.49998C5.625 2.33422 5.55915 2.17525 5.44194 2.05804C5.32473 1.94083 5.16576 1.87498 5 1.87498C4.83424 1.87498 4.67527 1.94083 4.55806 2.05804C4.44085 2.17525 4.375 2.33422 4.375 2.49998V4.99998C4.37504 5.16572 4.44091 5.32467 4.55813 5.44185L6.32563 7.20998C6.38369 7.26805 6.45263 7.31411 6.5285 7.34554C6.60437 7.37696 6.68569 7.39314 6.76781 7.39314C6.84993 7.39314 6.93125 7.37696 7.00712 7.34554C7.08299 7.31411 7.15193 7.26805 7.21 7.20998C7.26807 7.15191 7.31413 7.08297 7.34556 7.0071C7.37699 6.93123 7.39316 6.84991 7.39316 6.76779C7.39316 6.68567 7.37699 6.60435 7.34556 6.52848C7.31413 6.45261 7.26807 6.38367 7.21 6.3256L5.625 4.74123V2.49998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.817f99178a9561f61258e82b3f8135b9.svg";
export { ForwardRef as ReactComponent };